/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CloneQueryRequest } from '../../models/clone-query-request';
import { QueryDto } from '../../models/query-dto';

export interface QueriesQueryIdClonePost$Json$Params {
  queryId: string;
      body?: CloneQueryRequest
}

export function queriesQueryIdClonePost$Json(http: HttpClient, rootUrl: string, params: QueriesQueryIdClonePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
  const rb = new RequestBuilder(rootUrl, queriesQueryIdClonePost$Json.PATH, 'post');
  if (params) {
    rb.path('queryId', params.queryId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueryDto>;
    })
  );
}

queriesQueryIdClonePost$Json.PATH = '/queries/{queryId}/clone';
